export default "/images/menus_variety_sm.jpg?ae98d402bd92ffd524f4f6d04f08d3f9";